import { useQuery } from '@tanstack/react-query';
import { useStore } from '../context/StoreContext';
import { categoriesAPI } from '../api';

export const categoriesKey = (storeId) => ['categories', storeId];

export function useCategories() {
  const { selectedStore } = useStore();
  const storeId = selectedStore?.id;
  return useQuery({
    queryKey: categoriesKey(storeId),
    queryFn: () => categoriesAPI.list(storeId).then((r) => r.data),
    enabled: !!storeId,
    // Categories change rarely — hold fresh for 10 minutes
    staleTime: 10 * 60 * 1000,
  });
}
